/**
 * Builds the `mailto:` composer for the invite sheet's `Share` control.
 *
 * Pure, no browser API. The same subject and body strings this file returns
 * also feed the `navigator.share` payload in `InviteShareHeader` and the pool
 * screen's own share button, so the three paths cannot drift.
 *
 * The body is not written here. `poolShareText.ts` owns the one sentence
 * every share path sends (ISSUE-952 R11); this file only wraps it in a
 * `mailto:` URL.
 */
import {
  SHARE_EMAIL_SUBJECT_PREFIX,
  SHARE_EMAIL_SUBJECT_SUFFIX,
} from "./inviteSheetCopy";
import { buildPoolShareMessage } from "./poolShareText";

export function buildInviteShareSubject(poolName: string): string {
  return `${SHARE_EMAIL_SUBJECT_PREFIX}${poolName}${SHARE_EMAIL_SUBJECT_SUFFIX}`;
}

export function buildInviteShareBody(input: {
  poolName: string;
  inviteUrl: string;
}): string {
  return buildPoolShareMessage(input);
}

export function buildInviteMailtoHref(input: {
  poolName: string;
  inviteUrl: string;
}): string {
  const subject = buildInviteShareSubject(input.poolName);
  const body = buildInviteShareBody(input);
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
